<template>
  <div style="height: 100%;width: 100%;">
    <Header></Header>
    <div class="main">
      <div class="mian-left">

        <Project></Project>
      </div>
      <div class="mian-right">
        <div class="nav" style="position: fixed;width: 100%;z-index: 2000;">

          <Nav></Nav>
        </div>
        <div class="main-content" style="margin-top: 85px;">
          <transition mode="out-in">
            <!-- <keep-alive > -->
            <RouterView></RouterView>
            <!-- </keep-alive> -->
          </transition>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import Nav from './components/Nav' //三期--包含仰拱部分
  // import Nav from './components/NavOne' 
  // import Nav from './components/NavTwo' //二期
  import Header from './components/Header'


  import Project from "./components/Project"
  import {
    users_tokenToUser
  } from "@/common/api.js"
  export default {
    name: 'app',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        showPath: true,
        pathArr: ['/noPage', "/login", "/"]
      }
    },
    components: {
      Nav,
      Header,
      Project
    },


    methods: {
      // GetQueryString(name) {
      //   console.log("name")
      //         var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      //         var r = window.location.search.substr(1).match(reg);
      //         if (r != null) return unescape(r[2]);
      //         return null;
      //       },
      // getUserInfoByToken(token){
      //   console.log('token',token)
      //   users_tokenToUser({
      //     token:token
      //   }).then((res) => {
      //     console.log(res)
      //     if(res.success){

      //     }
      //   }).catch((err) => {
      //     console.log(err)

      //   })
      // },
      routerChange() {
        // this.path = this.$route.path
        //  console.log(this.path)
        // let pathArr = ['/noPage',"/login","/"]
        //  console.log(this.$route.path)
        // if(pathArr.indexOf(this.$route.path) ==-1){
        // 	this.showPath = true
        // }else{
        // 	this.showPath = false
        // }
      }
    },
    created() {




    },
    watch: {
      "$route": "routerChange"
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/layout/index.vue